import { getConstituentDocumentAction } from '../redux/Reducers/constituentDocumentReducer';
import { BASE_URL } from './BASE_URL';

export const getConstituentDocuments = () => {
  return async (dispatch) => {
    const response = await fetch(BASE_URL + 'information/constituent-documents/');
    const data = await response.json();

    if (response.status === 200) {
      dispatch(getConstituentDocumentAction(data));
    }
  };
};
